<template>
  <div class="homepage-2">
    <ScrollupSection />
    <div class="main">
      <HeaderSection />
      <HeroSection :data="hero" />
      <DiscoverSection :data="discover" />
      <FeatureSection :data="features" />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/ScrollupSection/scrollUp'
import HeaderSection from '../components/HeaderSection/headerOne'
import HeroSection from '../components/HeroSection/hero'
import FeatureSection from '../components/FeatureSection/feature'
import DiscoverSection from '../components/DiscoverSection/discover'
import FooterSection from '../components/FooterSection/footerOne'

export default {
  name: 'PageTurnkeyWeb',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    FeatureSection,
    DiscoverSection,
    FooterSection
  },
  data () {
    return {
      hero: {
        image: 'assets/img/enterprise/games/sword.jpg',
        title: 'Audience Insight',
        subtitle: 'An analytics platform built exclusively for the entertainment industry.',
        text: 'Pulse is an analytics platform made specifically for the entertainment industry. Able to scale to *trillions of hits per second and get live feedback, see audience reaction and emotions in real-time from millions of users at once, pulse lets you see into your audience in ways never before possible.',
        bottomText: '* On-prem and Cloud offerings available.'
      },
      features: {
        header: 'Bring your games into reality',
        features: [          
          {
            icon: 'flaticon-tap',
            title: 'Tappable actions',
            text: 'Smart Content that can be tapped and interacted with.'
          },
          {
            icon: 'flaticon-fingerprint',
            title: 'More engagement',
            text: 'Import player preferences, behaviors and things they care about.'
          },
          {
            icon: 'flaticon-notification',
            title: 'Programmatic display',
            text: 'Show smart content based on quests, events, locations, scores and more.'
          },
          {
            icon: 'flaticon-place',
            title: 'Augment real locations',
            text: 'Add location-based content like weather and time of day without effort.'
          },
          {
            icon: 'flaticon-settings',
            title: 'Unlimited possibilities',
            text: 'Hundreds of settings, themes and events to choose from'
          },
          {
            icon: 'flaticon-language',
            title: 'Realtime',
            text: 'Offer in-game chat, networking and other features in minutes.'
          }
        ]
      },
      discover: {
        image: 'assets/img/enterprise/games/unreal.jpg',
        title: 'Pulse is a pixel.',
        subtitle: 'Add pulse analytics anywhere by simply requesting a pixel.',
        features: [
          'One-line pixel embed code, virtually identical to Google Analytics or Facebook Pixel.',
          'Link areas directly to specific content, random or programmatic based on rules.',
          'Link activity within content back to your game.',
          'Automate deals based on IAB categories in your worlds and locations.',
          'Let your players sponsor you by creating NFTs linked to in-game items or content.',
          'Connect NFTs to real-world items like game items, characters, art and other merchandise in the real-world.'
        ]
      }
    }
  }
}
</script>

<style>

</style>